import { sanitizeInternalUrls } from '@packages/shared/src/utils/sanitizeInternalUrls/sanitizeInternalUrls';

/**
 * Fetches data from a specified endpoint and revalidates the data at a specified interval.
 *
 * @template T The expected return type from the fetch request.
 * @param {string} endpoint The URL from which to fetch data.
 * @param {number} [revalidateTime=60] The time in seconds at which to revalidate the data. Defaults to 60 seconds.
 */
export const bucketFetcher =
  <T>(endpoint: string, revalidateTime = 60, tags?: string[]) =>
  (): Promise<T> =>
    fetch(endpoint, {
      next: { revalidate: revalidateTime, tags },
    })
      .then((res) => {
        if (!res.ok) {
          // throw error when response status not ok -> error boundary catches and logs the error
          throw new Error(`Endpoint: ${res.url} - Status ${res.status}: ${res.statusText}`);
        }
        return res.json();
      })
      .then(sanitizeInternalUrls<T>);
